// extracted by mini-css-extract-plugin
export default {"fixedWidth":"TeamList_fixedWidth__y9p10"};